import request from "./request";
import constants, {
  PROPERTY_ARI_PREFIX,
  PROPERTY_CONFIGURATION_PREFIX,
  PROPERTY_DATA_PREFIX,
  PROXY_API_URL,
  PROXY_DEV_API_URL,
} from "./constants";
import moment from "moment";
import { cloneDeep } from "lodash";

// FIXME: once the clone is unified with master this should be removed
export function generateURL(path, apiPrefix = "/api") {
  const adjustedPath = path[0] !== "/" ? `/${path}` : path;
  const basePath = process.env.NODE_ENV === "production" ? PROXY_API_URL : PROXY_DEV_API_URL;
  const basePathWithPrefix = basePath.replace("/PREFIX_PLACEHOLDER", apiPrefix);
  if (process.env.NODE_ENV === "production") {
    if (window) {
      const currentDomain = `${window.location.protocol}//${window.location.host}${apiPrefix}`;
      return `${currentDomain}${adjustedPath}`;
    }
    return `${basePathWithPrefix}${adjustedPath}`;
  }
  return `${basePathWithPrefix}${adjustedPath}`;
}

export function secureHeader(token) {
  return {};
}

export function secureRequest({ getState, dispatch }, uri, options = {}) {
  const { headers = {} } = options;
  const token = "token";
  if (!token) {
    /* TODO: SECURE REQUESTS */
  }
  return request(uri, {
    ...options,
    headers: {
      ...headers,
      ...secureHeader(token),
    },
  }).then(response => {
    const { err } = response;
    if (err && err.response && err.response.status === 401) {
      /* TODO: HANDLE UNAUTHORIZED */
    }
    return response;
  });
}

export function requestSharedBooking(store, { key }) {
  const uri = generateURL(`bookings/${key}`);
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function requestCountries(store, { locale }) {
  const uri = generateURL(`property/countries/${locale}`);
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function requestPropertyData(store, { propertyTicker, locale, sessionId }) {
  const uri = generateURL(
    `property/${propertyTicker}/${locale}/propertyData${
      sessionId ? "?sessionId=" + sessionId : ""
    }`,
    PROPERTY_DATA_PREFIX
  );
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function requestConfiguration(store, { propertyTicker }) {
  const uri = generateURL(
    `property/${propertyTicker}/configuration`,
    PROPERTY_CONFIGURATION_PREFIX
  );
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

function calculateServicesDateQuantity({ propertyARI, propertyTicker }) {
  const services = { ...propertyARI[propertyTicker].services };
  for (const ticker in services) {
    if (services.hasOwnProperty(ticker)) {
      const service = { ...services[ticker] };
      service.dateQuantity = {};

      if (
        propertyARI[propertyTicker] &&
        propertyARI[propertyTicker].arivalues &&
        propertyARI[propertyTicker].arivalues[ticker] &&
        propertyARI[propertyTicker].arivalues[ticker].totalRatePerDay
      ) {
        for (const date in propertyARI[propertyTicker].arivalues[ticker].totalRatePerDay) {
          if (propertyARI[propertyTicker].arivalues[ticker].totalRatePerDay.hasOwnProperty(date)) {
            service.dateQuantity[date] = 1;
          }
        }
      }

      services[ticker] = service;
    }
  }

  return services;
}

export async function requestARI(
  store,
  {
    propertyTicker,
    locale,
    start,
    end,
    seniors,
    adults,
    teenagers,
    children,
    babies,
    propertyTickers,
    promoCodes,
    channel,
    inventoryTickersLikeFilter,
    inventoryTickersEqualFilter,
    guestAges,
    ignoredConfiguration,
    deviceInfo,
    totalAmount,
    reservationAmount,
    ipInfo,
    sessionId,
  }
) {
  const uri = generateURL(`property/${propertyTicker}/${locale}/propertyARI`, PROPERTY_ARI_PREFIX);
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      start: moment(start).format("YYYY-MM-DD"),
      end: moment(end).format("YYYY-MM-DD"),
      seniors,
      adults,
      teenagers,
      children: Array.isArray(guestAges) && guestAges.length ? undefined : children,
      babies: Array.isArray(guestAges) && guestAges.length ? undefined : babies,
      propertyTickers,
      promoCodes: promoCodes && promoCodes.map(code => code.replaceAll("ñ", "n")),
      inventoryTickersLikeFilter,
      inventoryTickersEqualFilter,
      guestAges,
      channel,
      ignoredConfiguration,
      deviceInfo,
      totalAmount:
        totalAmount && totalAmount.value && totalAmount.value.amount ? totalAmount : null,
      reservationAmount:
        reservationAmount && reservationAmount.value && reservationAmount.value.amount
          ? reservationAmount
          : null,
      locationInfo: {
        countryCode: ipInfo && ipInfo.country,
        cityName: ipInfo && ipInfo.cityName,
      },
      sessionId,
    }),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }

    // This is a requirement for booking engine
    const propertyARI = data;
    if (propertyARI && propertyARI[propertyTicker] && propertyARI[propertyTicker].services) {
      propertyARI[propertyTicker].services = calculateServicesDateQuantity({
        propertyARI,
        propertyTicker,
      });
    }

    return Promise.resolve(propertyARI);
  });
}

export function postPCITransaction(
  store,
  { reservationId, transactionId, propertyTicker, cardHolderName, expireDate, cardCode }
) {
  //eslint-disable-line
  const uri = generateURL(`integrations/pciproxy/tokens`);
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      reservationId,
      transactionId,
      propertyTicker,
      cardHolderName,
      expireDate,
      cardCode,
    }),
  }).then(({ data, headers, err }) => {
    // eslint-disable-line
    console.log("postPCITransaction");
    if (err) {
      console.log(err);
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    console.log(uri);
    console.log(data);
    return Promise.resolve({ resource: headers.get("location") });
  });
}

export function postReservation(store, { reservationData, method = "POST" }, url = "") {
  const uri = generateURL(`properties/reservations${url}`);
  return secureRequest(store, uri, {
    method: method,
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reservationData),
  }).then(({ data, headers, err }) => {
    // eslint-disable-line
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve({ resource: headers.get("location") });
  });
}

export async function putReservation(store, { reservationData, method = "PUT" }) {
  await postReservation(store, { reservationData, method }, "/extras");
}

export function requestReservation(store, { reservationId, propertyTicker, locale }) {
  const getParams = locale ? `?language=${locale}` : ``;
  const uri = generateURL(`properties/${propertyTicker}/reservations/${reservationId}${getParams}`);
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function cancelReservation(store, { reservationId, propertyTicker, cancellationReason }) {
  const reservationData = {
    propertyTicker,
    reservationId,
    cancellationReason,
  };

  const uri = generateURL(`properties/${propertyTicker}/reservations`);
  return secureRequest(store, uri, {
    method: "DELETE",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(reservationData),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function requestCalendarARI(store, { propertyTicker, start, end, ticker }) {
  let uri = generateURL(
    `hotel/${propertyTicker}/ari/calendar?startDate=${moment(start).format(
      "YYYY-MM-DD"
    )}&endDate=${moment(end).format("YYYY-MM-DD")}`
  );
  if (ticker) {
    uri = generateURL(
      `hotel/${propertyTicker}/ari?startDate=${moment(start).format("YYYY-MM-DD")}&endDate=${moment(
        end
      ).format("YYYY-MM-DD")}&inventoryTicker=${ticker}`
    );
  }
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve({ data, start, end, ticker, propertyTicker });
  });
}

export function createTransaction(store, { propertyTicker, idReservation, url, locale }) {
  const uri = generateURL(`payments/tpv/transactions/${propertyTicker}`);
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      idReservation,
      domain: url,
      language: locale,
    }),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function payNoPainDigest(store, { propertyTicker, idReservation, language }) {
  const uri = generateURL("payments/paynopain/digest");
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      reservationId: idReservation,
      hotelTicker: propertyTicker,
      description: constants.PAY_NO_PAIN.BOOKING_ENGINE_CHARGE,
      language,
      isTest: false,
    }),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

// TODO: ADD GET TRANSACTION ENDPOINT FUNCTION
// {{springServer}}api/payments/paynopain/transactions/hoteldemo.com.v6/M3144808
// Transactions come in a list of descending chronological order, take the first transaction from the list to know the details of the transaction failure.
// To Test more easily when the modal opens, alter the last transaction's response code of the M3144808 reservation in showcase's db and set a false value
// Once done, alter the inner IFRAME URL and set
// http://localhost:3000/hoteldemo.com.v6/payments/paynopain/M8256422/failure
// http://localhost:3000/hoteldemo.com.v6/payments/paynopain/M8256422/success
/*
 window.parent.postMessage({
 propertyTicker: "hoteldemo.com.v6",
 reservationId: "M8256422",
 status: "failure",
 }, '*');
*/
export function getPayNoPainTransactions(store, { reservationId, propertyTicker }) {
  const uri = generateURL(`payments/paynopain/transactions/${propertyTicker}/${reservationId}`);
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function createStripeFirstCharge(
  store,
  { reservationId, propertyTicker, stripeToken, currency, email, description, locale }
) {
  const uri = generateURL(`payments/stripe`);
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      stripeToken: stripeToken,
      hotelTicker: propertyTicker,
      reservationId: reservationId,
      currencyCode: currency,
      email: email,
      description: description,
      locale: locale,
    }),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function createPayPalCharge(store, { reservationId, propertyTicker }) {
  if (window && window.paypal) {
    const uri = generateURL(`payments/paypal/creations`);

    return window.paypal.request
      .post(uri, {
        propertyTicker,
        reservationId,
      })
      .then(res => {
        return res.paymentID;
      });
  }
}

export function payPalExecution(store, { payerID, propertyTicker, reservationId }, callback) {
  if (window && window.paypal) {
    const uri = generateURL(`payments/paypal/executions`);

    window.paypal.request
      .post(uri, {
        payerID,
        propertyTicker,
        reservationId,
      })
      .then(() => {
        callback();
      });
  }
}

export function createSharedBooking(store, { cart, propertyTicker, locale, urlParams }) {
  const uri = generateURL(`bookings/create`);
  const body = {
    cart: cart[propertyTicker].map(r => {
      const services = cloneDeep(r.selectedServices);
      Object.keys(services).forEach(key => {
        delete services[key].formValues;
      });
      return {
        start: new Date(r.startDate).toISOString(),
        end: new Date(r.endDate).toISOString(),
        guestAges: r.guestAges,
        numberOfUnits: r.numberOfUnits,
        propertyTicker: r.propertyTicker,
        inventory: r.inventory,
        id: r.id,
        services,
      };
    }),
    locale: locale,
    promoCodes: cart[propertyTicker].map(r => r.promoCodes).flat(1),
    urlParams,
  };
  return secureRequest(store, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  }).then(({ headers, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve({ resource: headers.get("location") });
  });
}

export function requestRecoverReservation(store, { reservationId, email }) {
  const uri = generateURL(`properties/reservations?reservationId=${reservationId}&email=${email}`);
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }

    return Promise.resolve(data);
  });
}

export function getAgentReport(store, { email, dateSearchCriteria, startDate, endDate }) {
  const uri = generateURL(
    `affiliates/${email}/report?startDate=${startDate}&endDate=${endDate}&dateSearchCriteria=${dateSearchCriteria}`
  );
  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }

    return Promise.resolve(data);
  });
}

export function createCustomerToken(store, { propertyTicker, customerId, paymentTicker }) {
  const uri = generateURL(
    `property/${propertyTicker}/engine/payments/${paymentTicker}/paynopain/customers/${customerId}`
  );
  return secureRequest(store, uri, { method: "PUT" }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }

    return Promise.resolve(data);
  });
}

export function updateCustomerCreditCardData(
  store,
  { propertyTicker, customerId, customerCreditCardData }
) {
  const uri = generateURL(
    `property/${propertyTicker}/engine/payments/paynopain/customers/${customerId}`
  );
  return secureRequest(store, uri, {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(customerCreditCardData),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }

    return Promise.resolve(data);
  });
}

export function createPaymentOrder(store, { propertyTicker, reservationId, orderId }) {
  const uri = generateURL(
    `payments/paynopainv2/properties/${propertyTicker}/reservations/${reservationId}/deposit/${orderId}`
  );

  return secureRequest(store, uri, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
      Accept: "application/json",
      "x-response-base-url": "https://v17.witbooking.com",
    },
    body: JSON.stringify({
      reservationId,
      propertyTicker,
      description: constants.PAY_NO_PAIN.BOOKING_ENGINE_CHARGE,
    }),
  }).then(({ data, statusCode, err }) => {
    if (err) {
      return Promise.reject(err);
    }

    return Promise.resolve({ data, statusCode });
  });
}

export function requestDeferredPaymentMethods(store, propertyTicker, reservationId) {
  const uri = generateURL(`properties/${propertyTicker}/reservations/${reservationId}/payments`);

  return secureRequest(store, uri, { method: "GET" }).then(({ data, err }) => {
    if (err) {
      console.error(err);
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function requestCartAbandonment(sessionId, payload) {
  const uri = generateURL(`cart/cart-abandonment-email/${sessionId}`);
  return secureRequest({}, uri, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }).then(({ data, err }) => {
    if (err) {
      return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
    }
    return Promise.resolve(data);
  });
}

export function createPnPErrorLog({ reservationId, rawEvent, message }) {
  try {
    const uri = generateURL(`properties/error-pnp`);
    return secureRequest({}, uri, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ reservationId, rawEvent, message }),
    }).then(({ data, err }) => {
      if (err) {
        return Promise.reject(constants.ERROR_TYPE.SERVER_ERROR);
      }
      return Promise.resolve(data);
    });
  } catch (exception) {
    console.error("Error creating PNP error log", exception);
  }
}
